var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.8626 40.1957C89.2875 41.7147 90 43.4869 90 45.5122C90 47.4986 89.2875 49.2514 87.8626 50.7704L83.5302 55.1522C82.0668 56.6322 80.3145 57.3723 78.2734 57.3723C76.1938 57.3723 74.4608 56.6322 73.0745 55.1522L56.0911 38.034V79.1644C56.0911 81.1898 55.3691 82.8354 53.9249 84.1012C52.4807 85.3671 50.7381 86 48.697 86H41.303C39.2619 86 37.5193 85.3671 36.0751 84.1012C34.6309 82.8354 33.9089 81.1898 33.9089 79.1644V38.034L16.9255 55.1522C15.5392 56.6322 13.8062 57.3723 11.7266 57.3723C9.64698 57.3723 7.91399 56.6322 6.5276 55.1522L2.19512 50.7704C0.731707 49.2903 0 47.5376 0 45.5122C0 43.4479 0.731707 41.6757 2.19512 40.1957L39.801 2.16168C41.1489 0.720562 42.8819 0 45 0C47.0796 0 48.8318 0.720562 50.2567 2.16168L87.8626 40.1957Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrowTop.259cbc6a6eee7e212182798f2fd59341.svg";
export { ForwardRef as ReactComponent };